<div>
<div class="row flex-sm-up align-items-center-sm-up mb-4">
	<div v-if="!isSharedMode" class="col-sm-8">
		<h1 >{{translations['Favorites.MyFavorites']}}</h1>
	</div>
	<div v-if="isSharedMode" class="col-sm-8">
		<h1 >{{translations['Favorites.SharedFavorites']}}</h1>
		<p class="text-small">
			<a alt="favorites url" :href="baseUrl()">[{{translations['Favorites.ViewMyFavorites']}}]</a>
		</p>
	</div>
	<div v-if="favoriteProducts.length" class="col-sm-4 text-right">
		<ul class="icons-list icons-list--inline icons-list--blue-links v-favorites__sharing">
			<li class="icons-list__item icons-block">
				<a href="#" class="icons-block__link js-print" @click="doPrint($event)">
					<i class="icon-print icons-block__icon"></i>
					<span class="icons-block__text">Print</span>
				</a>
			</li>
			<li v-if="!isSharedMode" class="icons-list__item icons-block">
				<div class="sharethis-inline-share-buttons" data-title="Favorites"></div>
			</li>
		</ul>
	</div>
</div>
<section v-if="favoriteProducts.length" >
		<h2 class="filter-projects__heading">Products</h2>		
        <div>
	       <ul class="product-grid mb-5" :class="'product-grid--4-col'">
		       <li v-for="(product, index) in favoriteProducts" class="product-grid__item">
		     	<product-card
				:displayName="product.displayName"
				:productDetailUrl="product.productDetailUrl"
				:availability="product.availability"
				:finish="product.finish"
				:productIndex="index"
				:primaryImageUrl="product.primaryImageUrl"
				:secondaryImageUrl="product.secondaryImageUrl"
				:alternateFinishes="product.alternateFinishes"
				:translations="translations"
				:stockNumber = "product.stockNumber"
				v-on:favoriteProductRemoved="favoriteProductRemoved"
			    />
		        </li>
	      </ul>
        </div>
</section>
<section v-if="workbenchProjects.length" class="section-large section-huge-sm-up position-relative">
	<h2 class="filter-projects__heading">Projects</h2>
	<div ref="resultsWrap" class="projects-card__results-wrap" >
		<div class="row flex-row align-items-stretch">
			<div class="col-sm-6 col-lg-4 mb-4 px-2" v-for="(project, index) in workbenchProjects" data-aos-once="true" data-aos="fade-up" :data-aos-delay="50 * index">
				<workbench-card
					:index="index"
					:baseUrl="pageData.BaseUrl"
					:urlName="project.UrlName"
					:heroImage="project.HeroImage"
					:heroImageAltText="project.HeroImageAltText"
					:ambassadorImage="project.Ambassador.Image"
					:ambassadorImageNormal="project.Ambassador.ImageNormal"
					:ambassadorImageNormalAltText="project.Ambassador.ImageNormalAltText"
					:ambassadorDisplayTitle="project.Ambassador.DisplayTitle"
					:projectTitle="project.DisplayTitle"
					:projectType="project.ArticleType"
					:difficulty="project.Difficulty"
					:time="project.Time"
					:translations="translations"
					v-on:favoriteProjectRemoved="favoriteProjectRemoved"
				/>
			</div>
		</div>		
	</div>	
</section>
<div class="load-indicator state-loading" v-if="isLoading">
	<div class="load-indicator__indicator"></div>
	<span class="load-indicator__text">Loading</span>
</div>
<div class="load-indicator-cover" v-if="isLoading"></div>
<p v-if="(!favoriteProducts.length) && (!workbenchProjects.length)" class="lead">
	{{translations['Favorites.NoSavedProducts']}}
</p>
</div>


